import { Staff } from '../../models/Entities/Staff/Staff';
import {
    CreateStaffCommand,
    StaffFilter,
    UpdateStaffCommand
} from '../../models/Entities/Staff/StaffCommands';
import { ErrorType } from '../../models/HttpError';
import { PaginationState } from '../../models/PaginationState';

// get staff page

export const STAFF_GETALL_REQUEST = 'STAFF_GETALL_REQUEST';
export const STAFF_GETALL_SUCCESS = 'STAFF_GETALL_SUCCESS';
export const STAFF_GETALL_FAILURE = 'STAFF_GETALL_FAILURE';

export interface StaffGetAllRequestAction {
    type: typeof STAFF_GETALL_REQUEST;
    filter: StaffFilter | undefined;
}

/**
 * El listado llega con su paginación al lado. Viaja junta con los registros y no
 * en una acción aparte porque describe a esta misma respuesta: separarlas deja
 * abierta la posibilidad de mostrar "página 3 de 7" sobre los datos de otra
 * búsqueda.
 */
export interface StaffGetAllSuccessAction {
    type: typeof STAFF_GETALL_SUCCESS;
    payload: Staff[];
    pagination: PaginationState;
}

export interface StaffGetAllFailureAction {
    type: typeof STAFF_GETALL_FAILURE;
    error: ErrorType;
}

// get staff member by id

export const STAFF_GETBYID_REQUEST = 'STAFF_GETBYID_REQUEST';
export const STAFF_GETBYID_SUCCESS = 'STAFF_GETBYID_SUCCESS';
export const STAFF_GETBYID_FAILURE = 'STAFF_GETBYID_FAILURE';

export interface StaffGetByIdRequestAction {
    type: typeof STAFF_GETBYID_REQUEST;
    payload: number;
}

export interface StaffGetByIdSuccessAction {
    type: typeof STAFF_GETBYID_SUCCESS;
    payload: Staff;
}

export interface StaffGetByIdFailureAction {
    type: typeof STAFF_GETBYID_FAILURE;
    error: ErrorType;
}

// create staff member

export const STAFF_CREATE_REQUEST = 'STAFF_CREATE_REQUEST';
export const STAFF_CREATE_SUCCESS = 'STAFF_CREATE_SUCCESS';
export const STAFF_CREATE_FAILURE = 'STAFF_CREATE_FAILURE';

export interface StaffCreateRequestAction {
    type: typeof STAFF_CREATE_REQUEST;
    payload: CreateStaffCommand;
}

/**
 * El alta responde con el id y nada más: para que la fila aparezca en la tabla
 * hay que volver a pedir la página, que es lo que hace el middleware.
 */
export interface StaffCreateSuccessAction {
    type: typeof STAFF_CREATE_SUCCESS;
    payload: number;
}

export interface StaffCreateFailureAction {
    type: typeof STAFF_CREATE_FAILURE;
    error: ErrorType;
}

// update staff member

export const STAFF_UPDATE_REQUEST = 'STAFF_UPDATE_REQUEST';
export const STAFF_UPDATE_SUCCESS = 'STAFF_UPDATE_SUCCESS';
export const STAFF_UPDATE_FAILURE = 'STAFF_UPDATE_FAILURE';

export interface StaffUpdateRequestAction {
    type: typeof STAFF_UPDATE_REQUEST;
    payload: UpdateStaffCommand;
}

export interface StaffUpdateSuccessAction {
    type: typeof STAFF_UPDATE_SUCCESS;
    payload: number;
}

export interface StaffUpdateFailureAction {
    type: typeof STAFF_UPDATE_FAILURE;
    error: ErrorType;
}

// delete staff member

export const STAFF_DELETE_REQUEST = 'STAFF_DELETE_REQUEST';
export const STAFF_DELETE_SUCCESS = 'STAFF_DELETE_SUCCESS';
export const STAFF_DELETE_FAILURE = 'STAFF_DELETE_FAILURE';

export interface StaffDeleteRequestAction {
    type: typeof STAFF_DELETE_REQUEST;
    payload: number;
}

export interface StaffDeleteSuccessAction {
    type: typeof STAFF_DELETE_SUCCESS;
    payload: number;
}

export interface StaffDeleteFailureAction {
    type: typeof STAFF_DELETE_FAILURE;
    error: ErrorType;
}
